// Fase 27A-F: helpers PUROS de ruteo de recuperación (#forgot-password, #reset-password?token=).
export type RecoveryView = { view: 'forgot' } | { view: 'reset'; token: string | null };

export function isRecoveryHash(hash: string): boolean {
  const seg = hash.replace(/^#/, '').split('?')[0].split('/').filter(Boolean);
  return seg[0] === 'forgot-password' || seg[0] === 'reset-password';
}

export function parseRecoveryHash(hash: string): RecoveryView {
  const raw = hash.replace(/^#/, '');
  const [pathPart, queryPart] = raw.split('?');
  const seg = pathPart.split('/').filter(Boolean);
  if (seg[0] === 'reset-password') {
    const token = new URLSearchParams(queryPart ?? '').get('token') ?? seg[1] ?? null;
    return { view: 'reset', token };
  }
  return { view: 'forgot' };
}
